function TrackEventDirective(analyticsService) {
  return {
    restrict: 'A',
    link: (scope, element, attrs) => {
      const action = attrs.eventAction;
      const category = attrs.eventCategory;
      const label = attrs.eventLabel;
      const value = attrs.eventValue;

      element.click(() => {
        analyticsService.trackEvent(action, {
          category,
          label,
          value
        });
      });
    }
  };
}

TrackEventDirective.$inject = [
  'analyticsService'
];

export default TrackEventDirective;



// WEBPACK FOOTER //
// ./src/directives/trackEvent.js